import { default as energy_45green_45practices9e12egzkrXMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyGtd6oSDtVMMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45buildergD5pyh1e27Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as indexzUPaG6VsG2Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45teambB8OXLa6GZMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lender0ePYjJJjIRMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resources1B5KE4om9MMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93pJb0IWNYnBMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexIyDFn2JprBMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as indexRhk5eX8tzdMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_930Blwq6nEXjMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as indexlG65yVLCeOMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offeriOHU9LbiOUMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45questionXfvq0eG5WIMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesGP8vwYABerMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqs5XDNPrpp9Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resources1YRn7bKzafMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as indexlRm4yBiK0rMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsscYsJs5rjBMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offersjAioiAgSfaMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexJOrRjVMSKVMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexDtHHPQBYRxMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as indexb99TyIsmDLMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexIGCAcwVAfdMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as index3UDJH6rTmXMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexVT4cPm6Zh1Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexjlYxcQJpGBMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationiR0tpNAItNMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionsxeyQGNUbwMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45place3wkDo1ze8OMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenance1eYcFjSUdEMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93wXmzxwf7RAMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexmo7zckx3oBMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as index5hJtEjG6MLMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullnessFnYBBNXk39Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93Jz4wipW6x4Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favorites4gJCgYE4UJMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45searchra7CmUq8M9Meta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhousecOTUPjWyUPMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionMFHrGsSg9bMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottageAtl6nZYHZyMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexdk0k9wp1tMMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoods3LTff2wEqgMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45usLEs9a0u5rnMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacockYgGgNa45nCMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsW1FBziWfShMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxZ0MuhSmuvrMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_9315hLeMaDReMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubFFoSZHZPTqMeta } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubFFoSZHZPTq } from "/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practices9e12egzkrXMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practices9e12egzkrXMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practices9e12egzkrXMeta || {},
    alias: energy_45green_45practices9e12egzkrXMeta?.alias || [],
    redirect: energy_45green_45practices9e12egzkrXMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyGtd6oSDtVMMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyGtd6oSDtVMMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyGtd6oSDtVMMeta || {},
    alias: fun_45part_45journeyGtd6oSDtVMMeta?.alias || [],
    redirect: fun_45part_45journeyGtd6oSDtVMMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45buildergD5pyh1e27Meta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45buildergD5pyh1e27Meta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45buildergD5pyh1e27Meta || {},
    alias: homesafe_45colorado_45master_45buildergD5pyh1e27Meta?.alias || [],
    redirect: homesafe_45colorado_45master_45buildergD5pyh1e27Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: indexzUPaG6VsG2Meta?.name ?? "about-us",
    path: indexzUPaG6VsG2Meta?.path ?? "/about-us",
    meta: indexzUPaG6VsG2Meta || {},
    alias: indexzUPaG6VsG2Meta?.alias || [],
    redirect: indexzUPaG6VsG2Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45teambB8OXLa6GZMeta?.name ?? "about-us-our-team",
    path: our_45teambB8OXLa6GZMeta?.path ?? "/about-us/our-team",
    meta: our_45teambB8OXLa6GZMeta || {},
    alias: our_45teambB8OXLa6GZMeta?.alias || [],
    redirect: our_45teambB8OXLa6GZMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lender0ePYjJJjIRMeta?.name ?? "about-us-preferred-lender",
    path: preferred_45lender0ePYjJJjIRMeta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lender0ePYjJJjIRMeta || {},
    alias: preferred_45lender0ePYjJJjIRMeta?.alias || [],
    redirect: preferred_45lender0ePYjJJjIRMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resources1B5KE4om9MMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resources1B5KE4om9MMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resources1B5KE4om9MMeta || {},
    alias: realtor_45resources1B5KE4om9MMeta?.alias || [],
    redirect: realtor_45resources1B5KE4om9MMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93pJb0IWNYnBMeta?.name ?? "blog-post",
    path: _91post_93pJb0IWNYnBMeta?.path ?? "/blog/:post()",
    meta: _91post_93pJb0IWNYnBMeta || {},
    alias: _91post_93pJb0IWNYnBMeta?.alias || [],
    redirect: _91post_93pJb0IWNYnBMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexIyDFn2JprBMeta?.name ?? "blog-category-category",
    path: indexIyDFn2JprBMeta?.path ?? "/blog/category/:category()",
    meta: indexIyDFn2JprBMeta || {},
    alias: indexIyDFn2JprBMeta?.alias || [],
    redirect: indexIyDFn2JprBMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexRhk5eX8tzdMeta?.name ?? "blog",
    path: indexRhk5eX8tzdMeta?.path ?? "/blog",
    meta: indexRhk5eX8tzdMeta || {},
    alias: indexRhk5eX8tzdMeta?.alias || [],
    redirect: indexRhk5eX8tzdMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930Blwq6nEXjMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_930Blwq6nEXjMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_930Blwq6nEXjMeta || {},
    alias: _91_46_46_46slug_930Blwq6nEXjMeta?.alias || [],
    redirect: _91_46_46_46slug_930Blwq6nEXjMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexlG65yVLCeOMeta?.name ?? "campaigns",
    path: indexlG65yVLCeOMeta?.path ?? "/campaigns",
    meta: indexlG65yVLCeOMeta || {},
    alias: indexlG65yVLCeOMeta?.alias || [],
    redirect: indexlG65yVLCeOMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offeriOHU9LbiOUMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offeriOHU9LbiOUMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offeriOHU9LbiOUMeta || {},
    alias: central_45park_45special_45offeriOHU9LbiOUMeta?.alias || [],
    redirect: central_45park_45special_45offeriOHU9LbiOUMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45questionXfvq0eG5WIMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45questionXfvq0eG5WIMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45questionXfvq0eG5WIMeta || {},
    alias: ask_45a_45questionXfvq0eG5WIMeta?.alias || [],
    redirect: ask_45a_45questionXfvq0eG5WIMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesGP8vwYABerMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesGP8vwYABerMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesGP8vwYABerMeta || {},
    alias: career_45opportunitiesGP8vwYABerMeta?.alias || [],
    redirect: career_45opportunitiesGP8vwYABerMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqs5XDNPrpp9Meta?.name ?? "contact-us-faq",
    path: faqs5XDNPrpp9Meta?.path ?? "/contact-us/faq",
    meta: faqs5XDNPrpp9Meta || {},
    alias: faqs5XDNPrpp9Meta?.alias || [],
    redirect: faqs5XDNPrpp9Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resources1YRn7bKzafMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resources1YRn7bKzafMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resources1YRn7bKzafMeta || {},
    alias: homeowner_45resources1YRn7bKzafMeta?.alias || [],
    redirect: homeowner_45resources1YRn7bKzafMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: indexlRm4yBiK0rMeta?.name ?? "contact-us",
    path: indexlRm4yBiK0rMeta?.path ?? "/contact-us",
    meta: indexlRm4yBiK0rMeta || {},
    alias: indexlRm4yBiK0rMeta?.alias || [],
    redirect: indexlRm4yBiK0rMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsscYsJs5rjBMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsscYsJs5rjBMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsscYsJs5rjBMeta || {},
    alias: our_45locationsscYsJs5rjBMeta?.alias || [],
    redirect: our_45locationsscYsJs5rjBMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offersjAioiAgSfaMeta?.name ?? "current-offers",
    path: current_45offersjAioiAgSfaMeta?.path ?? "/current-offers",
    meta: current_45offersjAioiAgSfaMeta || {},
    alias: current_45offersjAioiAgSfaMeta?.alias || [],
    redirect: current_45offersjAioiAgSfaMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexJOrRjVMSKVMeta?.name ?? "events-event",
    path: indexJOrRjVMSKVMeta?.path ?? "/events/:event()",
    meta: indexJOrRjVMSKVMeta || {},
    alias: indexJOrRjVMSKVMeta?.alias || [],
    redirect: indexJOrRjVMSKVMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexDtHHPQBYRxMeta?.name ?? "events",
    path: indexDtHHPQBYRxMeta?.path ?? "/events",
    meta: indexDtHHPQBYRxMeta || {},
    alias: indexDtHHPQBYRxMeta?.alias || [],
    redirect: indexDtHHPQBYRxMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexb99TyIsmDLMeta?.name ?? "homes-location-community",
    path: indexb99TyIsmDLMeta?.path ?? "/homes/:location()/:community()",
    meta: indexb99TyIsmDLMeta || {},
    alias: indexb99TyIsmDLMeta?.alias || [],
    redirect: indexb99TyIsmDLMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexIGCAcwVAfdMeta?.name ?? "homes-location-community-models-model",
    path: indexIGCAcwVAfdMeta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexIGCAcwVAfdMeta || {},
    alias: indexIGCAcwVAfdMeta?.alias || [],
    redirect: indexIGCAcwVAfdMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: index3UDJH6rTmXMeta?.name ?? "homes-location-community-plans-plan",
    path: index3UDJH6rTmXMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: index3UDJH6rTmXMeta || {},
    alias: index3UDJH6rTmXMeta?.alias || [],
    redirect: index3UDJH6rTmXMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexVT4cPm6Zh1Meta?.name ?? "homes-location-community-qmi-home",
    path: indexVT4cPm6Zh1Meta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexVT4cPm6Zh1Meta || {},
    alias: indexVT4cPm6Zh1Meta?.alias || [],
    redirect: indexVT4cPm6Zh1Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjlYxcQJpGBMeta?.name ?? "index",
    path: indexjlYxcQJpGBMeta?.path ?? "/",
    meta: indexjlYxcQJpGBMeta || {},
    alias: indexjlYxcQJpGBMeta?.alias || [],
    redirect: indexjlYxcQJpGBMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationiR0tpNAItNMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationiR0tpNAItNMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationiR0tpNAItNMeta || {},
    alias: knolls_45hoa_45informationiR0tpNAItNMeta?.alias || [],
    redirect: knolls_45hoa_45informationiR0tpNAItNMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionsxeyQGNUbwMeta?.name ?? "land-acquisition",
    path: land_45acquisitionsxeyQGNUbwMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionsxeyQGNUbwMeta || {},
    alias: land_45acquisitionsxeyQGNUbwMeta?.alias || [],
    redirect: land_45acquisitionsxeyQGNUbwMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45place3wkDo1ze8OMeta?.name ?? "lifestyle-brents-place",
    path: brents_45place3wkDo1ze8OMeta?.path ?? "/lifestyle/brents-place",
    meta: brents_45place3wkDo1ze8OMeta || {},
    alias: brents_45place3wkDo1ze8OMeta?.alias || [],
    redirect: brents_45place3wkDo1ze8OMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenance1eYcFjSUdEMeta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenance1eYcFjSUdEMeta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenance1eYcFjSUdEMeta || {},
    alias: experience_45lower_45maintenance1eYcFjSUdEMeta?.alias || [],
    redirect: experience_45lower_45maintenance1eYcFjSUdEMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93wXmzxwf7RAMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93wXmzxwf7RAMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93wXmzxwf7RAMeta || {},
    alias: _91testimonial_93wXmzxwf7RAMeta?.alias || [],
    redirect: _91testimonial_93wXmzxwf7RAMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: indexmo7zckx3oBMeta?.name ?? "lifestyle-reviews-category-category",
    path: indexmo7zckx3oBMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: indexmo7zckx3oBMeta || {},
    alias: indexmo7zckx3oBMeta?.alias || [],
    redirect: indexmo7zckx3oBMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index5hJtEjG6MLMeta?.name ?? "lifestyle-reviews",
    path: index5hJtEjG6MLMeta?.path ?? "/lifestyle/reviews",
    meta: index5hJtEjG6MLMeta || {},
    alias: index5hJtEjG6MLMeta?.alias || [],
    redirect: index5hJtEjG6MLMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullnessFnYBBNXk39Meta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullnessFnYBBNXk39Meta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullnessFnYBBNXk39Meta || {},
    alias: whats_45lifefullnessFnYBBNXk39Meta?.alias || [],
    redirect: whats_45lifefullnessFnYBBNXk39Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Jz4wipW6x4Meta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93Jz4wipW6x4Meta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93Jz4wipW6x4Meta || {},
    alias: _91_46_46_46slug_93Jz4wipW6x4Meta?.alias || [],
    redirect: _91_46_46_46slug_93Jz4wipW6x4Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites4gJCgYE4UJMeta?.name ?? "my-favorites",
    path: my_45favorites4gJCgYE4UJMeta?.path ?? "/my-favorites",
    meta: my_45favorites4gJCgYE4UJMeta || {},
    alias: my_45favorites4gJCgYE4UJMeta?.alias || [],
    redirect: my_45favorites4gJCgYE4UJMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45searchra7CmUq8M9Meta?.name ?? "new-home-search",
    path: new_45home_45searchra7CmUq8M9Meta?.path ?? "/new-home-search",
    meta: new_45home_45searchra7CmUq8M9Meta || {},
    alias: new_45home_45searchra7CmUq8M9Meta?.alias || [],
    redirect: new_45home_45searchra7CmUq8M9Meta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhousecOTUPjWyUPMeta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhousecOTUPjWyUPMeta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhousecOTUPjWyUPMeta || {},
    alias: easyhousecOTUPjWyUPMeta?.alias || [],
    redirect: easyhousecOTUPjWyUPMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionMFHrGsSg9bMeta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionMFHrGsSg9bMeta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionMFHrGsSg9bMeta || {},
    alias: limitededitionMFHrGsSg9bMeta?.alias || [],
    redirect: limitededitionMFHrGsSg9bMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottageAtl6nZYHZyMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottageAtl6nZYHZyMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottageAtl6nZYHZyMeta || {},
    alias: wee_45cottageAtl6nZYHZyMeta?.alias || [],
    redirect: wee_45cottageAtl6nZYHZyMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexdk0k9wp1tMMeta?.name ?? "our-homes",
    path: indexdk0k9wp1tMMeta?.path ?? "/our-homes",
    meta: indexdk0k9wp1tMMeta || {},
    alias: indexdk0k9wp1tMMeta?.alias || [],
    redirect: indexdk0k9wp1tMMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoods3LTff2wEqgMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoods3LTff2wEqgMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoods3LTff2wEqgMeta || {},
    alias: our_45neighborhoods3LTff2wEqgMeta?.alias || [],
    redirect: our_45neighborhoods3LTff2wEqgMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45usLEs9a0u5rnMeta?.name ?? "partner-with-us",
    path: partner_45with_45usLEs9a0u5rnMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45usLEs9a0u5rnMeta || {},
    alias: partner_45with_45usLEs9a0u5rnMeta?.alias || [],
    redirect: partner_45with_45usLEs9a0u5rnMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacockYgGgNa45nCMeta?.name ?? "peacock",
    path: peacockYgGgNa45nCMeta?.path ?? "/peacock",
    meta: peacockYgGgNa45nCMeta || {},
    alias: peacockYgGgNa45nCMeta?.alias || [],
    redirect: peacockYgGgNa45nCMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsW1FBziWfShMeta?.name ?? "privacyterms",
    path: privacytermsW1FBziWfShMeta?.path ?? "/privacyterms",
    meta: privacytermsW1FBziWfShMeta || {},
    alias: privacytermsW1FBziWfShMeta?.alias || [],
    redirect: privacytermsW1FBziWfShMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxZ0MuhSmuvrMeta?.name ?? "sandbox",
    path: sandboxZ0MuhSmuvrMeta?.path ?? "/sandbox",
    meta: sandboxZ0MuhSmuvrMeta || {},
    alias: sandboxZ0MuhSmuvrMeta?.alias || [],
    redirect: sandboxZ0MuhSmuvrMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_9315hLeMaDReMeta?.name ?? "videos-slug",
    path: _91_46_46_46slug_9315hLeMaDReMeta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_9315hLeMaDReMeta || {},
    alias: _91_46_46_46slug_9315hLeMaDReMeta?.alias || [],
    redirect: _91_46_46_46slug_9315hLeMaDReMeta?.redirect,
    component: () => import("/codebuild/output/src3719946950/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/build-with-us/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/career-opportunities/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/email-signup/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/get-updates/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/how-to-video-library/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/lifestyle/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/login/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/lost-password/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/maintenance-items/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/organism-page/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/register/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/reset-password/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/style-guide/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  },
  {
    name: component_45stubFFoSZHZPTqMeta?.name ?? undefined,
    path: component_45stubFFoSZHZPTqMeta?.path ?? "/warranty-service-request/",
    meta: component_45stubFFoSZHZPTqMeta || {},
    alias: component_45stubFFoSZHZPTqMeta?.alias || [],
    redirect: component_45stubFFoSZHZPTqMeta?.redirect,
    component: component_45stubFFoSZHZPTq
  }
]